import { useGenerationConfirm } from './useGenerationConfirm';
import { useStreamHandler } from './useStreamHandler';

export function useAssistantActions() {
  const { handleGenerationConfirm, handleGenerationCancel } = useGenerationConfirm();
  const { handleSendMessage, handleStopGeneration, refreshChatHistoryRef } = useStreamHandler();

  return {
    handleStopGeneration,
    handleGenerationConfirm,
    handleGenerationCancel,
    handleSendMessage,
    refreshChatHistoryRef,
  };
}
